module.exports = __webpack_public_path__ + "static/media/pla_saf_cli.b16a781f.png";